export const SUPPORTED_FILE_TYPES = [
  "application/pdf",
  "application/x-pdf",
  "application/xls",
  "application/xlsx",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/powerpoint",
  "application/vnd.ms-powerpoint",
  "application/mspowerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const MAX_FILE_SIZE = 100000001;
